<div class="modal-header">
  <h4 i18n="@@supervisor-message-header">Nachricht vom Supervisor</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="this.bsModalRef.hide()"
  ></button>
</div>
<div class="modal-body">
  <p>{{supervisorMessage.content}}</p>
</div>
<div class="modal-footer">
  <form
    class="d-flex w-100 gap-2"
    (submit)="sendAnswerTosupervisor()"
  >
    <input
      pInputText
      name="answerText"
      type="text"
      class="flex-grow-1"
      aria-label="Antwort eingeben"
      i18n-aria-label="@@supervisor-message-answer-label"
      [(ngModel)]="this.answerText"
      (keyup.enter)="sendAnswerTosupervisor()"
    >
    <p-button
      type="submit"
      label="Senden"
      i18n-label="@@send"
      [disabled]="this.answerText.trim() === ''"
    ></p-button>
  </form>
</div>